import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { filter, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { OrderApi } from 'shared/sdk';

@Component({
  selector: 'app-sales-order-lookup',
  templateUrl: './sales-order-lookup.component.html',
  styleUrls: ['./sales-order-lookup.component.css']
})
export class SalesOrderLookupComponent implements OnInit {

  public searchInput = new EventEmitter<string>();

  @Input() set resetData(isClear) {
    if(isClear) {
      this.selectedSalesOrder = [];
    }
  }
  @Input() isMultiSelect = true;
  @Input() placeholder = 'Sales Order Number';
  @Output() getSalesOrderObj: EventEmitter<any> = new EventEmitter();
  salesOrderList: any;  
  itemsPerBatch = 50;
  notFoundText: string;
  orderBy = 'id DESC';
  selectedSalesOrder: any[];
  whereFilter: any;

  constructor(private _salesOrderApi: OrderApi) { }

  ngOnInit() {
    const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
    this.selectedSalesOrder = (preselected && preselected['salesOrder']) ?
      preselected['salesOrder'] : [];

    if (this.selectedSalesOrder && this.selectedSalesOrder.length) {
      this.whereFilter = { Work_Order_num__c: { inq: this.selectedSalesOrder } };
      this.loadSalesOrderNumber().subscribe(
        x => {
          this.salesOrderList = x;
          this.notFoundText = (this.salesOrderList.length === 0) ? 'No sales order found.' : '';
        },
        err => {
          this.salesOrderList = [];
        }
      )
    }
    this.getSalesOrderNumber();
  }

  getSalesOrderNumber() {
    this.searchInput
      .pipe(
        filter(search => search && search.length > 5),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(search => this.loadSalesOrderNumber(search))
      ).subscribe(
        x => {
          this.salesOrderList = x;
          this.notFoundText = (this.salesOrderList.length === 0) ? 'No sales order found.' : '';
        },
        err => {
          console.log(err);
          this.salesOrderList = [];
        }

      );
  }

  loadSalesOrderNumber(search?) {
    if (search) {
      const searchPattern = { ilike: '%' + search.trim() + '%', options: 'i' };
      this.whereFilter = { ...this.whereFilter, OrderNumber: searchPattern };
    }

    const reqObj = {
      'fields': ['OrderNumber','sfdcId'],
      'where': this.whereFilter,
      limit: this.itemsPerBatch,
      order: this.orderBy
    };
    return this._salesOrderApi.find(reqObj);
  }

  clearSalesOrder() {
    this.selectedSalesOrder = [];
    this.notFoundText = 'Type to search sales order.';
    this.getSalesOrderObj.emit([]);
  }

  onSalesOrderChange() {
    this.getSalesOrderObj.emit(this.selectedSalesOrder);
  }
}
